module.exports = __webpack_public_path__ + "img/electronic_enabled.1b7921c0.svg";